<template>
  <div class="dialog-mask" @click.self="close">
    <div class="dialog-content">
      <div class="dialog-header">
        <h2 class="dialog-title">{{ title }}</h2>
        <button class="close-icon-btn" @click="close"><IconClose /></button>
      </div>
      <div class="dialog-body">{{ content }}</div>
      <footer>
        <button class="close-btn" @click="close">{{ $t("common.close") }}</button>
      </footer>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import IconClose from "~icons/figma/Close";

export default Vue.extend({
  components: { IconClose },
  props: {
    title: {
      type: String,
      required: true,
    },
    content: {
      type: String,
      required: true,
    },
  },
  methods: {
    close() {
      this.$close(true);
    },
  },
});
</script>

<style lang="scss" scoped>
.dialog-mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  z-index: 9000;
  align-items: center;
  justify-content: center;
  background-color: var(--color-overlay);
}

.dialog-content {
  position: relative;
  padding: 16px;
  width: 416px;
  box-sizing: border-box;
  max-height: 80vh;
  border-radius: var(--radius-sm);
  background-color: var(--color-background-normal);
  color: var(--color-text-normal);
  display: flex;
  flex-direction: column;
  overflow: hidden;

  @include mq("sp") {
    width: calc(100% - 32px);
  }
}

.dialog-header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}

.dialog-title {
  font-size: 16px;
  font-weight: var(--font-weight-bold);
  margin: 0;
}

.close-icon-btn {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  color: var(--color-text-low);

  svg {
    width: 16px;
    height: 16px;
  }

  &:hover {
    color: var(--color-text-normal);
  }
}

.dialog-body {
  font-size: 14px;
  line-height: 1.7;
  white-space: pre-line;
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  margin-right: -16px;
  padding-right: 16px;
}

footer {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.close-btn {
  padding: 8px;
  border-radius: var(--radius-rounded);
  border: 1px solid var(--color-border);
  background-color: var(--color-surface-base);
  font-size: 16px;
  font-weight: var(--font-weight-bold);
  cursor: pointer;
  color: var(--color-text-normal);
  width: 100%;
}
</style>
